import style from '../PaymentStatusScreen.module.css';

interface WidgetProps {
    widget : any
}
const PaymentDetails = ({widget} : WidgetProps) => {
    const copy = (value : string) => {
        navigator.clipboard.writeText(value);

    }
    return <div className="card border-0 shadow-sm">
        <div className="card-body d-flex gap-2 flex-column">
            {widget.paymentDetailsList.map((paymentDetails : any,index : number) => {
                return <div className="d-flex justify-content-between " key={index}>
                    <span style={{color : "#606060"}} className={style.text_14}>{paymentDetails.label.text}</span>
                    <span className={`${style.paymentDetails_value} `} style={{backgroundColor : `${paymentDetails.value.style.backgroundColor == '#00FFFFFF' ? '#FFFFFF' : paymentDetails.value.style.backgroundColor}`, border : `1px solid ${paymentDetails.value.style.borderColor == '#00FFFFFF' ? '#FFFFFF' : paymentDetails.value.style.borderColor}` }}>{paymentDetails.value.actionText && <span className='text-primary fw-bold hoverPointer' onClick={() => {copy(paymentDetails.value.style.copyValue)}}>{paymentDetails.value.actionText}</span>} <span className={`${paymentDetails.value.style.isBold ? "fw-bold" : ""}`} style={{color : `${paymentDetails.value.style.textColor}`}}>{paymentDetails.value.text}</span></span>
            </div>})}
        </div>
    </div>
}

export default PaymentDetails;